import React from 'react';
import { NavLink, Outlet, Link, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Building2, Inbox, Package, LogOut } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import LanguageSelect from '../../components/language/LanguageSelect';

const items = [
  ['', LayoutDashboard, 'Overview'],
  ['merchants', Building2, 'Merchants'],
  ['leads', Inbox, 'Leads'],
  ['plans', Package, 'Plans'],
];

export default function AdminLayout() {
  const nav = useNavigate();
  const { profile, signOut } = useAuth();
  return (
    <div className="min-h-screen bg-rozops-bg flex">
      <aside className="w-64 bg-rozops-navy text-white/80 min-h-screen sticky top-0 flex flex-col">
        <Link to="/admin" className="flex items-center px-5 h-16 border-b border-white/10">
          <span className="inline-flex rounded-xl bg-white px-2 py-1">
            <img src="/ro-icon.png" alt="RozOps Admin" className="h-9 w-9 object-contain" />
          </span>
        </Link>
        <nav className="p-3 flex-1 space-y-1">
          {items.map(([t, Icon, l]) => (
            <NavLink key={t} to={t === '' ? '/admin' : `/admin/${t}`} end={t === ''} data-testid={`admin-nav-${t || 'overview'}`}
              className={({ isActive }) => `flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-semibold transition-all ${isActive ? 'bg-white/10 text-white' : 'text-white/60 hover:bg-white/5 hover:text-white'}`}>
              <Icon className="w-4 h-4" /> {l}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-white/10">
          <div className="text-xs text-white/50">Signed in</div>
          <div className="text-sm text-white truncate">{profile?.full_name || profile?.email}</div>
          <button onClick={async () => { await signOut(); nav('/login', { replace: true }); }} data-testid="admin-logout" className="mt-2 w-full flex items-center gap-2 px-3 py-2 rounded-xl text-sm text-white/70 hover:bg-white/5">
            <LogOut className="w-4 h-4" /> Log out
          </button>
        </div>
      </aside>
      <main className="flex-1 p-8">
        <div className="mb-4 flex justify-end">
          <LanguageSelect compact />
        </div>
        <Outlet />
      </main>
    </div>
  );
}
